import {Component, OnInit} from '@angular/core';
import { Router } from '@angular/router';
import { SecureTokenService } from './services/secure-token.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./css/capd.css']
})
export class AppComponent implements OnInit {
  title = 'capd-admin';

  constructor(private router: Router) {}

  ngOnInit(): void {
    window.addEventListener('pageshow', () => {
      const hasValidToken = !!SecureTokenService.getAccessToken();
      const isAuthenticatedRoute = window.location.hash.includes('#/main') || window.location.hash.includes('/main');

      if (isAuthenticatedRoute && !hasValidToken) {
        const wasExplicitlyLoggedOut = SecureTokenService.wasExplicitlyLoggedOut();
        sessionStorage.clear();
        if (wasExplicitlyLoggedOut) {
          SecureTokenService.markLoggedOut();
        }
        SecureTokenService.clearTokens();
        this.router.navigate(['login']);
      }
    });

    window.addEventListener('popstate', () => {
      const hasValidToken = !!SecureTokenService.getAccessToken();
      const isAuthenticatedRoute = window.location.hash.includes('#/main') || window.location.hash.includes('/main');

      if (isAuthenticatedRoute && !hasValidToken) {
        const wasExplicitlyLoggedOut = SecureTokenService.wasExplicitlyLoggedOut();
        sessionStorage.clear();
        if (wasExplicitlyLoggedOut) {
          SecureTokenService.markLoggedOut();
        }
        SecureTokenService.clearTokens();
        this.router.navigate(['login']);
      }
    });
  }
}
